import React from 'react';
import { Box, Grid } from '@mui/material';
import { LineChart, Line, XAxis, YAxis, Tooltip, AreaChart, Area, CartesianGrid, Legend } from 'recharts';
import KPIGrid from '../components/KPIGrid';
import ChartCard from '../components/ChartCard';

const RetentionTab = ({ data }) => {
    if (!data) return <div>Loading...</div>;

    const { kpis, retentionSeries, churnSeries, cohorts } = data;

    return (
        <Box height="100%">
            <KPIGrid kpis={kpis} />

            <Grid container spacing={3}>
                <Grid item xs={12} md={8}>
                    <ChartCard title="Retention Rates over Time">
                        <LineChart data={retentionSeries}>
                             <CartesianGrid strokeDasharray="3 3" opacity={0.3} />
                             <XAxis dataKey="date" />
                             <YAxis unit="%" />
                             <Tooltip formatter={(val) => `${val}%`} />
                             <Legend />
                             <Line type="monotone" dataKey="d1" stroke="#8884d8" name="D1" />
                             <Line type="monotone" dataKey="d7" stroke="#82ca9d" name="D7" />
                             <Line type="monotone" dataKey="d30" stroke="#ffc658" name="D30" />
                        </LineChart>
                    </ChartCard>
                </Grid>
                <Grid item xs={12} md={4}>
                    <ChartCard title="Premium Churn Trend">
                        <AreaChart data={churnSeries}>
                             <CartesianGrid strokeDasharray="3 3" opacity={0.3} />
                             <XAxis dataKey="date" />
                             <YAxis unit="%" />
                             <Tooltip formatter={(val) => `${val}%`} />
                             <Legend />
                             <Area type="monotone" dataKey="value" stroke="#ff8042" fill="#ff8042" fillOpacity={0.3} name="Churn %" />
                        </AreaChart>
                    </ChartCard>
                </Grid>
                {/* Cohort visualization can go here, but simple table is enough */}
            </Grid>
        </Box>
    );
};

export default RetentionTab;
